import { container, title } from "../../../material-kit-pro-react.jsx";

const pillsStyle = {
  section: {
    padding: "70px 0"
  },
  container,
  title: {
    ...title,
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  }
};

export default pillsStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/componentsSections/pillsStyle.jsx